import * as THREE from 'three';
// import Arrow from '../objects/arrow';
import Arrow3D from '@scene/objects/arrow3D';

/* eslint-disable */
export function createArrow(direction, isSingle = true, options = {}) {
  const arrow = new Arrow3D({
    position: options.position || new THREE.Vector3(0, 0, 0),
    size: options.size || 100,
    color: typeof options.color === 'number' ? options.color : 0xff0000,
    isSingle,
    direction
  });

  const LINE = 0;
  arrow.mesh.children[0].children[0].material.depthTest = false;

  const CONUS = 1;
  arrow.mesh.children[0].children[1].material.depthTest = false;

  if (!isSingle) {
    arrow.mesh.children[0].children[2].material.depthTest = false;
  }

  return arrow;
}

export function isConvex(vertices) {
  if (vertices.length === 1) return true; // true for circle

  if (vertices.length < 2) return false;

  let oldPoint = vertices[vertices.length - 2];
  let newPoint = vertices[vertices.length - 1];
  let newDirection = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);

  let angleSum = 0;
  let orientation;

  for (let i = 0; i < vertices.length; i++) {
    const point = vertices[i];

    oldPoint = newPoint;
    let oldDirection = newDirection;
    newPoint = point;
    newDirection = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);

    if (oldPoint.x === newPoint.x && oldPoint.y === newPoint.y) return false;

    let angle = newDirection - oldDirection;

    if (angle <= -Math.PI) {
      angle += Math.PI * 2;
    } else if (angle > Math.PI) {
      angle -= Math.PI * 2;
    }

    if (i === 0) {
      if (angle === 0) {
        return false;
      }

      orientation = angle > 0 ? 1 : -1;
    } else {
      if (orientation * angle <= 0) {
        return false;
      }
    }

    angleSum += angle;
  }

  return Math.abs(Math.round(angleSum / (Math.PI * 2))) == 1;
}

function getSides({ panel, ground }, screwPositions) {
  const panelHalfWidth = panel.width / 2;
  const panelHalfHeight = panel.height / 2;

  const padding = {
    left: panelHalfWidth + defaultPadding,
    right: panelHalfWidth + defaultPadding,
    top: panelHalfHeight + defaultPadding,
    bottom: panelHalfHeight + defaultPadding
  };

  if (ground.padding.C1x !== null) {
    padding.right = Math.abs(screwPositions.left.y) + ground.padding.C1x;
  }

  if (ground.padding.C2x !== null) {
    padding.left = Math.abs(screwPositions.right.y) + ground.padding.C2x;
  }

  if (ground.padding.C1y !== null) {
    padding.top = Math.abs(screwPositions.bottom.z) + ground.padding.C1y;
  }

  if (ground.padding.C2y !== null) {
    padding.bottom = Math.abs(screwPositions.top.z) + ground.padding.C2y;
  }

  return padding;
}



// WEBPACK FOOTER //
// ./src/object-view/services/helper.js